<template>
  <modal
    v-slot="{ data }"
    name="twoFactorAuthModal"
    modal-style="compact"
    :is-required="true"
  >
    <two-factor-auth
      v-bind="data"
      :on-success="data.onSuccess"
    />
  </modal>
</template>


<script>
  import TwoFactorAuth from './two-factor-auth/index.vue';


  export default {
    name: 'TwoFactorAuthModal',

    components: {
      TwoFactorAuth
    }
  };
</script>
